import * as Icons from '@tradersclub/core-icons/web';

import * as S from './styles';
import { IconProps } from './types';

const Icon = ({
  name,
  color,
  margin,
  size = `small`,
  hideOnMobile = false,
  hideOnDesktop = false,
}: IconProps) => {
  const IconTC = Icons[name];

  if (!IconTC) return null;

  return (
    <S.Wrapper
      color={color}
      margin={margin}
      size={size}
      hideOnMobile={hideOnMobile}
      hideOnDesktop={hideOnDesktop}
    >
      <IconTC />
    </S.Wrapper>
  );
};

export default Icon;
